module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Dinner-c846fa05239a3d458714727f21b867e5.svg";